import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { OutsideClickModule } from 'app/shared/click/ls-outside-click.module';
import { SharedModule } from '../../../../shared.module';
import { PillModule } from '../../../pill/pill.module';
import { LsFormMultiSelectComponent } from './ls-form-multi-select.component';
import { LsMultiSelectComponent } from './ls-multi-select.component';

@NgModule({
  imports: [
    CommonModule,
    OutsideClickModule,
    PillModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [LsMultiSelectComponent, LsFormMultiSelectComponent],
  exports: [LsMultiSelectComponent, LsFormMultiSelectComponent]
})
export class LsMultiSelectModule {}
